import React from "react";
import PropTypes from "prop-types";
import { Select } from 'semantic-ui-react';
import _ from 'lodash';

export function asNumber(value) {
  if (value === "") {
    return undefined;
  }
  if (/\.$/.test(value)) {
    // "3." can't really be considered a number even if it parses in js. The
    // user is most likely entering a float.
    return value;
  }
  if (/\.0$/.test(value)) {
    // we need to return this as a string here, to allow for input like 3.07
    return value;
  }
  const n = Number(value);
  const valid = typeof n === "number" && !Number.isNaN(n);

  if (/\.\d*0$/.test(value)) {
    // It's a number, that's cool - but we need it as a string so it doesn't screw
    // with the user when entering dollar amounts or other values (such as those with
    // specific precision or number of significant digits)
    return value;
  }

  return valid ? n : value;
}

/**
 * This is a silly limitation in the DOM where option change event values are
 * always retrieved as strings.
 */
function processValue({ type, items }, value) {
  if (value === "") {
    return undefined;
  } else if (
    type === "array" &&
    items &&
    ["number", "integer"].includes(items.type)
  ) {
    return value.map(asNumber);
  } else if (type === "boolean") {
    return value === "true";
  } else if (type === "number") {
    return asNumber(value);
  } else if (type === "object") {
    return JSON.parse(value);
  }
  return value;
}

/*function getValue(event, multiple) {
  if (multiple) {
    return [].slice
      .call(event.target.options)
      .filter(o => o.selected)
      .map(o => o.value);
  } else {
    return event.target.value;
  }
}*/

function SelectWidget(props) {
  const {
    schema,
    id,
    options,
    value,
    disabled,
    readonly,
    multiple,
    autofocus,
    onChange,
    onBlur,
    placeholder,
    formContext,
    registry,
    ...selectProps
  } = props;

  const enumOptions = options.enumOptions.map(({ value, label }, i) => {
    return {
      key: i,
      value: _.isObject(value) ? JSON.stringify(value) : value,
      text: label
    };
  });

  const defaultOption = { value: '', text: placeholder };
  if (!multiple && !schema.default) {
    enumOptions.unshift(defaultOption);
  }

  const emptyValue = multiple ? [] : '';
  const stringValue = _.isObject(value) ? JSON.stringify(value) : value;

  return (
    <Select
      id={id}
      multiple={multiple}
      value={typeof value === 'undefined' ? emptyValue : stringValue}
      disabled={disabled || readonly}
      autoFocus={autofocus}
      options={enumOptions}
      {...selectProps}
      onBlur={
        onBlur &&
        ((event, data) => {
          //const newValue = getValue(event, multiple);
          const newValue = data.value;
          onBlur(id, processValue(schema, newValue));
        })
      }
      onChange={(event, data) => {
        //const newValue = getValue(event, multiple);
        const newValue = data.value;
        onChange(processValue(schema, newValue));
      }} />
  );
}

SelectWidget.defaultProps = {
  autofocus: false,
};

SelectWidget.propTypes = {
  schema: PropTypes.object.isRequired,
  id: PropTypes.string.isRequired,
  options: PropTypes.shape({
    enumOptions: PropTypes.array,
  }).isRequired,
  value: PropTypes.any,
  required: PropTypes.bool,
  disabled: PropTypes.bool,
  readonly: PropTypes.bool,
  multiple: PropTypes.bool,
  autofocus: PropTypes.bool,
  onChange: PropTypes.func,
  onBlur: PropTypes.func,
};

export default SelectWidget;



// WEBPACK FOOTER //
// ./src/components/ui/semantic-form/widgets/select-widget.js